import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { AyndriMark } from "@/components/brand/AyndriLogo";

export const PortalModal = ({ title, wide = false, brand = false, onClose, children, testId }) => (
  <Dialog.Root open onOpenChange={(o) => { if (!o) onClose(); }}>
    <Dialog.Portal>
      <Dialog.Overlay className="rx-overlay" />
      <Dialog.Content className={`modal ${wide ? "wide" : ""}`} data-testid={testId} aria-describedby={undefined}>
        <div className="modal-h">
          <div className="modal-title">
            {brand && <AyndriMark size={30} />}
            <Dialog.Title asChild><h2>{title}</h2></Dialog.Title>
          </div>
          <Dialog.Close className="close" aria-label="Close dialog" data-testid="modal-close-button"><X size={16} /></Dialog.Close>
        </div>
        <div className="modal-body">{children}</div>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);

export const DemoNotice = ({ children, testId = "demo-mode-notice" }) => (
  <div className="notice warn" data-testid={testId}><b>DEMO MODE · </b>{children}</div>
);

export const Field = ({ id, label, error, hint, children }) => (
  <div className="field">
    <label htmlFor={id}>{label}</label>
    {children}
    {hint && !error && <small>{hint}</small>}
    {error && <small className="err" data-testid={`${id}-error`}>{error}</small>}
  </div>
);
